import { useTouchscreenContext } from "./TouchscreenProvider.js";

export const DEFAULT_BRAND_KEY = "startle";

/**
 * Just the key — loading the actual brand (typefaces, imagery, layout metrics) is
 * `@touchscreen/brand-kit`'s job via its runtime registry. Falls back to the default brand
 * before the session resolves (Find Me, on the phone) and on any unrecognised key, so a venue
 * never renders broken because a brand build hasn't shipped yet.
 *
 * `?brand=` in the URL, when present, overrides `venue.brand_key` entirely. This is a deliberate
 * product decision (not the old "read brand from the URL" pattern touchscreen-frontend.md warns
 * against) — it exists so a brand can be forced/enforced for a given screen regardless of what
 * the venue's server-side `brand_key` says, e.g. previewing or QA-ing a theme before it's rolled
 * out venue-by-venue. Venue context stays the source of truth whenever the param is absent.
 */
export function useBrand(): { brandKey: string; resolved: boolean } {
  const { venue } = useTouchscreenContext();
  return {
    brandKey: readBrandOverride() ?? venue?.brand_key ?? DEFAULT_BRAND_KEY,
    resolved: venue !== null,
  };
}

function readBrandOverride(): string | null {
  if (typeof window === "undefined") return null;
  return new URLSearchParams(window.location.search).get("brand");
}
